export async function retry<T>(
    fn: () => Promise<T>,
    retries = 3,
    delayMs = 1000,
    shouldRetry: (error: unknown) => boolean = () => true
  ): Promise<T> {
    let lastError;
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        return await fn();
      } catch (err) {
        lastError = err;
        if (!shouldRetry(err)) {
          throw err;
        }
        console.warn(`Attempt ${attempt} failed. Retrying in ${delayMs}ms...`, err);
        if (attempt < retries) {
          await new Promise(res => setTimeout(res, delayMs));
        }
      }
    }
    throw lastError;
  }
  
  export function asRealPromise<T>(thenable: PromiseLike<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      thenable.then(resolve, reject);
    });
  }

  